export default __webpack_public_path__ + "static/media/4.4c252d91.jpg";